module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOpenFinance),
      expression: "showOpenFinance"
    }],
    staticClass: "row col-xs-10"
  }, [_c('label', {
    staticClass: "control-label open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.titulo'))
    }
  }), (!_vm.bankAccount.optIn || !((!!_vm.bankAccount.optIn.belvoLinkId && _vm.bankAccount.optIn.statusAceite === "2") || _vm.bankAccount.optIn.statusAceite === "1")) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('toggle-button', {
    attrs: {
      "color": "#147d96",
      "sync": true
    },
    model: {
      value: (_vm.enableOfdaForm),
      callback: function($$v) {
        _vm.enableOfdaForm = $$v
      },
      expression: "enableOfdaForm"
    }
  }), _c('label', {
    staticClass: "control-label open-finance",
    staticStyle: {
      "margin-left": "0.5vh"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.compartilhar'))
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableOfdaForm),
      expression: "enableOfdaForm"
    }],
    staticClass: "col-xs-12 open-finance-box"
  }, [_c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoConta'))
    }
  }), _c('div', {
    staticClass: "radio radio-success no-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoConta),
      expression: "tipoConta"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoConta",
      "id": "tipoContaPf"
    },
    domProps: {
      "value": 'PF',
      "checked": _vm._q(_vm.tipoConta, 'PF')
    },
    on: {
      "change": function($event) {
        _vm.tipoConta = 'PF'
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "tipoContaPf"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoContaPf'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoConta),
      expression: "tipoConta"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoConta",
      "id": "tipoContaPj"
    },
    domProps: {
      "value": 'PJ',
      "checked": _vm._q(_vm.tipoConta, 'PJ')
    },
    on: {
      "change": function($event) {
        _vm.tipoConta = 'PJ'
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "tipoContaPj"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoContaPj'))
    }
  })])]), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "requisitante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.requisitante'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requisitante),
      expression: "requisitante"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('requisitante', 'formOFDA')
    },
    attrs: {
      "id": "requisitante",
      "name": "requisitante",
      "data-vv-scope": "formOFDA"
    },
    domProps: {
      "value": (_vm.requisitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requisitante = $event.target.value
      }
    }
  }), (_vm.errors.has('requisitante', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "cpfRequisitante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.cpfRequisitante'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          digits: 11,
          cpfValido: true
        }
      }),
      expression: "{ rules: { required: true, digits: 11, cpfValido: true} }"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('cpfRequisitante', 'formOFDA')
    },
    attrs: {
      "id": "cpfRequisitante",
      "name": "cpfRequisitante",
      "mask": "###.###.###-##",
      "data-vv-scope": "formOFDA"
    },
    model: {
      value: (_vm.cpf),
      callback: function($$v) {
        _vm.cpf = $$v
      },
      expression: "cpf"
    }
  }), (_vm.errors.has('cpfRequisitante', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.cpfInvalido'))
    }
  }) : _vm._e()], 1), (_vm.tipoConta === 'PJ') ? _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "empresa"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.empresa'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empresa),
      expression: "empresa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('empresa', 'formOFDA')
    },
    attrs: {
      "id": "empresa",
      "name": "empresa",
      "data-vv-scope": "formOFDA"
    },
    domProps: {
      "value": (_vm.empresa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.empresa = $event.target.value
      }
    }
  }), (_vm.errors.has('empresa', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "cnpjRequisitante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.cnpjRequisitante'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          min: 14,
          max: 14,
          cnpjValido: true
        }
      }),
      expression: "{ rules: { required: true, min: 14, max: 14, cnpjValido: true} }"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('cnpjRequisitante', 'formOFDA')
    },
    attrs: {
      "id": "cnpjRequisitante",
      "name": "cnpjRequisitante",
      "mask": "XX.XXX.XXX/XXXX-XX",
      "data-vv-scope": "formOFDA"
    },
    model: {
      value: (_vm.cnpj),
      callback: function($$v) {
        _vm.cnpj = $$v
      },
      expression: "cnpj"
    }
  }), (_vm.errors.has('cnpjRequisitante', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.cnpjInvalido'))
    }
  }) : _vm._e()], 1)]) : _vm._e()])])]) : _vm._e(), (_vm.bankAccount.optIn && ((!!_vm.bankAccount.optIn.belvoLinkId && _vm.bankAccount.optIn.statusAceite === "2") || _vm.bankAccount.optIn.statusAceite === "1")) ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.jaAutorizado'))
    }
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e804536c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e804536c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/bankAccounts/belvoWidget.pug
// module id = 1465
// module chunks = 0